import React, { useState, useEffect } from "react";
import { Box, VStack } from "native-base";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";

const Sortable = (props) => {
  const [items, setItems] = useState(props.items);
  useEffect(() => {
    setItems(props.items);
  }, [props.items]);
  let idField = props.idField || "id";
  let sortField = props.sortField || "sort_order";

  const SortableItem = SortableElement(({ item }) => {
    const SortableBox = React.cloneElement(props.component, {
      item: item,
    });

    return <Box>{SortableBox}</Box>;
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <VStack space={5}>
        {items?.map((item, index) => (
          <SortableItem key={`item-${index}`} index={index} item={item} />
        ))}
      </VStack>
    );
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    let _items = arrayMoveImmutable(items, oldIndex, newIndex);
    // _items = { ..._items };
    let sortedItems = [];
    for (let i = 0; i < _items.length; i++) {
      // _items[i][sortField] = i + 1;
      let sortedItem = {
        ["note_id"]: _items[i][idField],
        [sortField]: i + 1,
      };
      sortedItems.push(sortedItem);
    }
    if (props.onSortChange) {
      props.onSortChange(sortedItems);
    }
    setItems(_items);
  };

  return (
    <Box>
      <SortableList items={items} onSortEnd={onSortEnd} distance={1} />
    </Box>
  );
};

export default Sortable;
